<template>
  <v-dialog v-model="model" :max-width="maxWidth" :persistent="true">
    <v-card>
      <v-flex>
        <v-card class="mb-3 mx-2">
          <v-card-title>
            <span class="headline">{{ title }}</span>
          </v-card-title>

          <m-pay-widget-item-editor
            :widgetItem="item"
            :loading="loading"
            @submit="updateWidgetItem"
            @cancel="cancelUpdate"
          />
        </v-card>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
import MPayWidgetItemEditor from './MPayWidgetItemEditor';

export default {

  name: 'MPayEditDialog',

  components: {
    MPayWidgetItemEditor,
  },

  props: {
    show: { type: Boolean, required: true },
    title: { type: String, required: true },
    description: { type: String, required: false },
    maxWidth: { type: String, required: false, default: '500px' },
    item: { type: Object, required: true },
  },

  data: () => ({
    loading: false,
  }),

  methods: {
    updateWidgetItem(item) {
      this.$emit('submit', item);
    },
    cancelUpdate() {
      this.$emit('cancel');
    },
  },

  computed: {
    model: {
      get() {
        return this.show;
      },
      set(newValue) {
        if (!newValue) {
          this.$emit('cancel');
        }
      },
    },
  },

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/merchant/MPayEditDialog.vue